export default "__VITE_ASSET__A$ZgZ59q__"